var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    { staticClass: "lesson-detail-actions" },
    [
      _c(
        "v-row",
        {
          staticClass: "gap-2",
          attrs: { "no-gutters": "", justify: "start", align: "center" },
        },
        [
          _vm._l(
            _setup.actions.filter((e) => !e.hidden()),
            function (action) {
              return _c(
                "v-btn",
                {
                  key: action.title,
                  attrs: {
                    disabled: action.disabled(),
                    rounded: "",
                    outlined: "",
                    small: "",
                    color: "accent",
                    href: action.link,
                  },
                  on: {
                    click: function ($event) {
                      return action.method()
                    },
                  },
                },
                [
                  _c("v-icon", { staticClass: "mr-1", attrs: { small: "" } }, [
                    _vm._v(_vm._s(action.icon)),
                  ]),
                  _vm._v(_vm._s(action.title)),
                ],
                1
              )
            }
          ),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-menu",
            {
              attrs: { "offset-y": "", left: "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function ({ on, attrs }) {
                    return [
                      _c(
                        "v-btn",
                        _vm._g(
                          _vm._b(
                            {
                              attrs: { icon: "", color: "dark" },
                              on: {
                                click: function ($event) {
                                  _setup.showLessonOptions =
                                    !_setup.showLessonOptions
                                },
                              },
                            },
                            "v-btn",
                            attrs,
                            false
                          ),
                          on
                        ),
                        [
                          _c(
                            "v-icon",
                            _vm._g(_vm._b({}, "v-icon", attrs, false), on),
                            [_vm._v("more_vert")]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _vm._v(" "),
              _c(
                "v-list",
                _vm._l(_setup.menuItems, function (item) {
                  return _c(
                    "v-list-item",
                    {
                      key: item.title,
                      attrs: { disabled: item.disabled() },
                      on: {
                        click: function ($event) {
                          return item.method()
                        },
                      },
                    },
                    [_c("v-list-item-title", [_vm._v(_vm._s(item.title))])],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _vm._l(_setup.forms, function (form, idx) {
        return _c(
          "div",
          { key: idx },
          [
            form.show
              ? _c(_setup.SimpleForm, {
                  attrs: {
                    title: form.title() ?? "Are you sure?",
                    subtitle: form.subtitle() ?? "",
                    submit: form.submit,
                  },
                  on: {
                    reset: function ($event) {
                      return _setup.reset($event)
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "body",
                        fn: function () {
                          return [
                            form.slot === "substituteTeacher"
                              ? _c("SoliTeachers", {
                                  attrs: {
                                    autocomplete: "",
                                    returnObject: false,
                                    filterTeacher: _vm.lesson.teacher.id,
                                    filterLocation:
                                      _vm.auth.user.selected_location.id,
                                    rules: [
                                      (v) =>
                                        !!v || v === 0 || "Item is required",
                                    ],
                                    all: true,
                                    hideDetails: "auto",
                                  },
                                  model: {
                                    value: form.submit.data.user_id,
                                    callback: function ($$v) {
                                      _vm.$set(form.submit.data, "user_id", $$v)
                                    },
                                    expression: "form.submit.data.user_id",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            form.slot === "confirmDelete"
                              ? _c(
                                  "v-radio-group",
                                  {
                                    staticClass: "mt-0",
                                    attrs: {
                                      rules: [
                                        (v) => v !== null || "Item is required",
                                      ],
                                    },
                                    model: {
                                      value: form.submit.data.cancelRepeating,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          form.submit.data,
                                          "cancelRepeating",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "form.submit.data.cancelRepeating",
                                    },
                                  },
                                  [
                                    _c("v-radio", {
                                      attrs: {
                                        value: true,
                                        label: "This and Following Lessons",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("v-radio", {
                                      attrs: {
                                        value: false,
                                        disabled:
                                          _setup.isRepeating &&
                                          _vm.lesson.type !== "Hold",
                                        label: "This Lesson",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            form.slot === "editCapacity"
                              ? _c("SoliText", {
                                  attrs: {
                                    number: "",
                                    label: "Student Capacity",
                                    "hide-details": "auto",
                                    icon: "people",
                                    min: 1,
                                    max: 100,
                                    rules: [
                                      (val) =>
                                        !!val || "This field is required",
                                      (val) =>
                                        val >= 1 ||
                                        "Capacity must be greater than 1",
                                      (val) =>
                                        val <= 100 ||
                                        "Capacity must be less than 100",
                                    ],
                                    validateOnBlur: false,
                                  },
                                  model: {
                                    value: form.submit.data.capacity,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        form.submit.data,
                                        "capacity",
                                        $$v
                                      )
                                    },
                                    expression: "form.submit.data.capacity",
                                  },
                                })
                              : _vm._e(),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                })
              : _vm._e(),
          ],
          1
        )
      }),
      _vm._v(" "),
      _setup.showAttendanceNotes
        ? _c(_setup.LessonAttendanceNotes, {
            attrs: {
              student: _vm.lesson.student,
              lessonNote: _setup.getLessonNote,
              practiceNote: _setup.getPracticeNote,
            },
            on: {
              reset: function ($event) {
                _setup.showAttendanceNotes = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _setup.snack
        ? _c("SoliSnack", { attrs: { text: _setup.snack, time: 3000 } })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }